<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs3 class="px-3" v-for="n in 4" :key="n ">
        <!--<v-card align-center align-content-center class="card__upload">
          <label :for="fileInput + n">
            <v-card-media :src="imagesSrc[n - 1] || 'https://api.ilewasi.org/images/default/user/camera_background.png'" height="200px"
              class="hidden-md-and-down">
            </v-card-media>
            <v-card-media :src="imagesSrc[n - 1] || 'https://api.ilewasi.org/images/default/user/camera_background.png'" height="150px"
              class="hidden-sm-and-down hidden-lg-and-up">
            </v-card-media>
            <v-card-media :src="imagesSrc[n - 1] || 'https://api.ilewasi.org/images/default/user/camera_background.png'" height="100px"
              class="hidden-xs-only hidden-md-and-up">
            </v-card-media>
            <v-card-media :src="imagesSrc[n - 1] || 'https://api.ilewasi.org/images/default/user/camera_background.png'" height="55px"
              class="hidden-sm-and-up">
            </v-card-media>
            <input :id="fileInput + n" type="file" accept="image/jpeg, image/png" v-on:change="setFile($event, n)">
          </label>
        </v-card>-->
        <picture-input
          ref="pictureInput"
          @change="onChange"
          @error="errorUpload"
          :crop="false"
          accept="image/jpeg,image/png"
          size="2"
          :zIndex="0"
          :hideChangeButton="true"
          :autoToggleAspectRatio="true"
          :plain="true"
          :prefill="imagesSrc[n - 1] || 'https://api.ilewasi.org/images/default/user/camera_background.png'"
        >
        </picture-input>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-form autocomplete="off">
          <v-text-field label="Título" v-model="title" required autocomplete="nope" :rules="[() => title.length > 0 || 'No hay título']"></v-text-field>
          <v-text-field label="Descripción" v-model="description" required autocomplete="nope" :rules="[() => description.length > 0 || 'No hay descripción']"></v-text-field>
          <v-text-field label="Notas" v-model="notes" autocomplete="nope"></v-text-field>
          <v-select label="Categoría" v-model="category" :items="categories" required item-text="name" item-value="code" single-line
            bottom></v-select>
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="progress" v-if="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-btn large block flat color="pink darken-1" class="headline font-600" @click="clickUpload">SUBEME</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-btn v-if="modify" large block flat color="primary" class="headline font-600" @click="deleteProduct">BORRAR</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PictureInput from 'vue-picture-input'

import HTTP from '@/axios-config'

export default {
  components: {
    PictureInput
  },
  name: 'Upload',
  data () {
    return {
      product: {},
      title: '',
      description: '',
      notes: '',
      category: {},
      organization: '',
      files: [],
      modify: false,
      imagesSrc: [],
      fileInput: 'file-input-',
      loading: false,
      categories: [{
        name: 'Ropa',
        code: 107
      }, {
        name: 'Comida',
        code: 101
      },
      {
        name: 'Juguetes',
        code: 102
      },
      {
        name: 'Libros',
        code: 103
      },
      {
        name: 'Ocio',
        code: 104
      },
      {
        name: 'Deportes',
        code: 105
      },
      {
        name: 'Otros',
        code: 106
      }
      ]
    }
  },
  created () {
    if (this.$route.params.product) {
      this.modify = true
      this.product = this.$route.params.product
      this.title = this.product.title
      this.description = this.product.description
      this.category = this.product.category
      this.notes = this.product.notes
      this.organization = this.product.organization
      this.owner = this.product.owner
      this.imagesSrc = this.product.pictures
      this.imagesSrc.forEach((item, index, array) => {
        if (item) this.files[index] = null
      })
    }
  },
  methods: {
    onChange (image) {
      if (image) {
        this.$refs.pictureInput.forEach((item, index, array) => {
          if (this.$refs.pictureInput[index].file.name !== 'camera_background.png') this.files[index] = this.$refs.pictureInput[index].file
        })
      } else {
        console.log('Picture Upload not supported')
      }
    },
    errorUpload (error) {
      this.$bus.$emit('event-toast', error.message)
    },
    clickUpload () {
      this.loading = true
      this.modify ? this.updateProduct() : this.uploadProduct()
    },
    uploadProduct () {
      let requestUploadProduct = {
        title: this.title,
        description: this.description,
        category: this.categories.find((item) => {
          return item.code === this.category
        }),
        notes: this.notes,
        organization: this.$store.getters.getUser.organization,
        owner: this.$store.getters.getUser._id
      }
      HTTP.post('/product/set', requestUploadProduct)
        .then(function (response) {
          this.product = response.data.result
          if (this.files.length > 0) {
            this.uploadImages()
          } else {
            this.loading = false
            this.$bus.$emit('event-toast', 'El producto se ha subido satisfactoriamente')
            this.$router.go(-1)
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    updateProduct () {
      let requestUpdateProduct = {
        title: this.title,
        description: this.description,
        category: this.categories.find((item) => {
          return item.code === this.category
        }),
        notes: this.notes,
        organization: this.$store.getters.getUser.organization,
        owner: this.$store.getters.getUser._id
      }
      HTTP.post('/product/update/' + this.product._id, requestUpdateProduct)
        .then(function (response) {
          this.product = response.data.result
          if (this.files.length > 0) {
            this.uploadImages()
          } else {
            this.loading = false
            this.$bus.$emit('event-toast', 'El producto se ha modificado satisfactoriamente')
            this.$router.go(-1)
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    deleteProduct () {
      HTTP.get('/product/delete/' + this.product._id)
        .then(function (response) {
          this.$bus.$emit('event-toast', 'El producto se ha borrado satisfactoriamente')
          this.product = {}
          this.title = ''
          this.description = ''
          this.notes = ''
          this.category = {}
          this.organization = ''
          this.files = []
          this.imagesSrc = []
          this.$router.go(-1)
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    setFile (e, n) {
      if (!e.target.files[0] && !e.dataTransfer.files[0]) {
        return
      }
      this.files[n - 1] = e.target.files[0] || e.dataTransfer.files[0]
      let reader = new FileReader()
      reader.onload = (e) => {
        this.imagesSrc[n - 1] = e.target.result
      }
      reader.readAsDataURL(this.files[n - 1])
    },
    uploadImages () {
      let promises = this.files.map((file) => {
        return this.uploadImage(file)
      })
      Promise.all(promises).then(() => {
        this.loading = false
        this.$bus.$emit('event-toast', 'El producto se ha subido satisfactoriamente')
        this.product = {}
        this.title = ''
        this.description = ''
        this.notes = ''
        this.category = {}
        this.organization = ''
        this.files = []
        this.imagesSrc = []
        this.$router.go(-1)
      })
        .catch((error) => {
          console.log(error)
          this.loading = false
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        })
    },
    uploadImage (file) {
      return new Promise((resolve, reject) => {
        // Split the base64 string in data and contentType
        // let block = file.split(';')
        // Get the content type of the image
        // let contentType = block[0].split(':')[1]// In this case "image/gif"
        // get the real base64 content of the file
        // let realData = block[1].split(',')[1]// In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        // let blob = this.b64toBlob(realData, contentType)
        if (file) {
          let data = new FormData()
          data.append(this.product._id, file)
          HTTP.post('/product/uploadProductPhoto/' + this.product._id, data)
            .then(function (response) {
              resolve()
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else resolve()
      })
    }
    /* b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512
      let byteCharacters = atob(b64Data)
      let byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)
        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        let byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      let blob = new Blob(byteArrays, {type: contentType})
      return blob
    } */
  }
}

</script>

<style scoped>
  .btn--active .btn__content:before,
  .btn:hover .btn__content:before,
  .btn:focus .btn__content:before {
    background-color: transparent !important;
  }

  .font-600 {
    font-weight: 600 !important;
  }

  .card__upload>label>input {
    display: none !important;
  }

  .progress {
    text-align: center !important;
  }

  .progress-circular {
    margin: 1rem
  }

</style>



// WEBPACK FOOTER //
// src/pages/Upload.vue